import routerOptions0 from "/home/runner/work/library-website-nuxt/library-website-nuxt/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@8.1.0_@parcel+watcher@2.5.1_@types+node@18.19.76_db0@0.2.4_eslint@_2aoycokfqukxu5fjqb6h5e2vxa/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/library-website-nuxt/library-website-nuxt/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}